import { Injectable } from '@angular/core';
import {
  ApiResponse,
  ErrorResponse,
  OtpPayload,
  OtpResponse,
  ResetPasswordPayload,
  Result,
} from '../models/common.model';
import { catchError, map, Observable, of, tap, throwError } from 'rxjs';
import { ApiService } from './api.service';
import { API_ENDPOINTS } from '../constants/api-endpoints.constants';
import { DemoRequestInquiry, ContactUsRequestInquiry } from '../models/inquiries.model';
import { environment } from '@environments/environment';
import { App } from '../models/app.model';
import { Group } from '../models/group.model';
import { Event } from '../models/event.model';
import { ErrorHandlingService } from './error-handling.service';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class CommonService {
  constructor(private apiService: ApiService, private errorHandlingService: ErrorHandlingService) { }

  //todo: return result
  verifyOtp(payload: OtpPayload): Observable<OtpResponse> {
    return this.apiService.post<OtpResponse>(API_ENDPOINTS.AUTH.VERIFY_OTP, payload).pipe(
      tap((res) => {
        return of({ success: true, data: res.data });
      }),
      catchError((error: ErrorResponse) => {
        return throwError(() => this.apiService.handleApiError<OtpResponse>(error));
      })
    );
  }

  resendOtp(payload: OtpPayload): Observable<OtpResponse> {
    return this.apiService.post<OtpResponse>(API_ENDPOINTS.AUTH.RESEND_OTP, payload).pipe(
      tap((res) => {
        return of({ success: true, data: res.data });
      }),
      catchError((error: ErrorResponse) => {
        return throwError(() => this.apiService.handleApiError<OtpResponse>(error));
      })
    );
  }

  //todo: return result - Done
  sendOtp(email: string, event: string): Observable<OtpResponse> {
    const OtpPayload = {
      emailId: email,
      event: event,
    };
    return this.apiService.post<OtpResponse>(API_ENDPOINTS.AUTH.SEND_OTP, OtpPayload).pipe(
      tap((res) => {
        return of({ success: true, data: res.data });
      }),
      catchError((error: ErrorResponse) => {
        return throwError(() => this.apiService.handleApiError<OtpResponse>(error));
      })
    );
  }

  // return result - Done
  resetPassword(uid: string, payload: ResetPasswordPayload): Observable<ApiResponse<void>> {
    return this.apiService
      .patch<ApiResponse<void>>(API_ENDPOINTS.AUTH.RESET_PASSWORD(uid), payload)
      .pipe(
        tap((res) => {
          return of({ success: true as const, data: res.data });
        }),
        catchError((error: ErrorResponse) => {
          return throwError(() => this.apiService.handleApiError<ApiResponse<void>>(error));
        })
      );
  }

  //  lead inquiries api call for guest page - demo and contact us api call - Completed
  inquiriesLead(payload: DemoRequestInquiry | ContactUsRequestInquiry): Observable<Result<void>> {
    const params = new HttpParams().set('inquiyKeyType', 'PRODUCT');
    // assuming API returns no data
    return this.apiService
      .post<ApiResponse<void>>(API_ENDPOINTS.COMMON.INQUIRIES_LEAD, payload, { params })
      .pipe(
        map((res) => ({
          success: true as const,
          data: res.data,
        })),
        tap((result) => {
          if (environment.consoleFlag && result.success) {
            console.log('✅ Inquiry lead submitted successfully');
          }
        }),
        catchError((error) => throwError(() => this.apiService.handleApiError<void>(error)))
      );
  }

  getSetupResource(orgId: string): Observable<Result<App[] | Group[] | Event[]>> {
    return this.apiService
      .get<ApiResponse<App[] | Group[] | Event[]>>(API_ENDPOINTS.COMMON.SETUP_RESOURCE(orgId))
      .pipe(
        map((res) => ({ success: true as const, data: res.data })),
        tap((result) => {
          if (environment.consoleFlag && result.success) {
            console.log('✅ Setup resource fetched successfully');
          }
        }),
        catchError((error: any) =>
          throwError(() => this.apiService.handleApiError<App[] | Group[] | Event[]>(error))
        )
      );
  }
}
